import { ColumnId, SortOptions } from '../../table';
import { NO_SCORE_NO_CLASS_ID } from '../fixture/no-score-no-class-id';
import { PerformerItemView } from '../model/performer-item-view.model';

function _dataForColumn(
    column: ColumnId,
    data: PerformerItemView,
): { value: any; type: 'string' | 'number' } {
    switch (column) {
        case ColumnId.PERFORMER:
            return { value: data.name, type: 'string' };
        case ColumnId.MI2_SCORE:
            return { value: data.mi2Score, type: 'number' };
        case ColumnId.IMPROVEMENT_CATEGORY:
            return {
                value:
                    data.improvementGroup?.scorecardImprovementCategoryId ===
                    NO_SCORE_NO_CLASS_ID
                        ? -NO_SCORE_NO_CLASS_ID
                        : -data.improvementGroup?.axisOrder ??
                          -NO_SCORE_NO_CLASS_ID,
                type: 'number',
            };
        case ColumnId.OA_SCORE:
            return { value: data.oaScore, type: 'number' };
        case ColumnId.MI2_PLUS_SCORE:
            return { value: data.mi2PlusScore, type: 'number' };
        case ColumnId.SCORECARD_POINTS:
            return { value: data.scorecardPoints, type: 'number' };
        case ColumnId.SCORECARD_PERFORMANCE_CLASS:
            return {
                value:
                    data.performanceClass?.scorecardPerformanceClassId ===
                    NO_SCORE_NO_CLASS_ID
                        ? -NO_SCORE_NO_CLASS_ID
                        : -data.performanceClass?.axisOrder ??
                          -NO_SCORE_NO_CLASS_ID,
                type: 'number',
            };
        case ColumnId.PREVIOUS_SCORECARD_POINTS:
            return { value: data.previousScorecardPoints, type: 'number' };
        case ColumnId.PREVIOUS_SCORECARD_PERFORMANCE_CLASS:
            return {
                value:
                    data.previousPerformanceClass
                        ?.scorecardPerformanceClassId === NO_SCORE_NO_CLASS_ID
                        ? -NO_SCORE_NO_CLASS_ID
                        : -data.previousPerformanceClass?.axisOrder ??
                          -NO_SCORE_NO_CLASS_ID,
                type: 'number',
            };
        case ColumnId.IMPROVEMENT_ACHIEVED:
            return { value: data.improvementAchieved, type: 'number' };
        case ColumnId.MOVEMENT_OF_RANKING:
            return { value: data.movementOfRanking, type: 'number' };
        default:
            return { value: null, type: null };
    }
}

function _sortColumn(
    valA: string | number | any,
    valB: string | number | any,
    type: 'string' | 'number',
    order: 'asc' | 'desc',
): number {
    if (type === 'number') {
        valA = valA == null ? Number.MIN_SAFE_INTEGER : valA;
        valB = valB == null ? Number.MIN_SAFE_INTEGER : valB;
    } else {
        valA = valA == null ? '' : valA;
        valB = valB == null ? '' : valB;
    }
    return type === 'number'
        ? order === 'asc'
            ? valA - valB
            : valB - valA
        : order === 'asc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
}

export function sortRows(
    rows: PerformerItemView[],
    nextSortOptions: SortOptions,
): PerformerItemView[] {
    const nextFilteredRows = [...rows];
    nextFilteredRows.sort((a, b) => {
        const av = _dataForColumn(nextSortOptions.columnId, a);
        const bv = _dataForColumn(nextSortOptions.columnId, b);
        let result = _sortColumn(
            av.value,
            bv.value,
            av.type,
            nextSortOptions.order,
        );
        // TODO write a recursion for this later
        if (result === 0) {
            /* // assume to always sort category desc
                const av2 = this._dataForColumn(PerformerDataColumnType.SCORECARD_MOVEMENT_BAND, a);
                const bv2 = this._dataForColumn(PerformerDataColumnType.SCORECARD_MOVEMENT_BAND, b);
                result = this._sortColumn(av2.value, bv2.value, av2.type, 'desc'); */
            if (result === 0) {
                // fallback sort by name asc
                const av3 = _dataForColumn(ColumnId.PERFORMER, a);
                const bv3 = _dataForColumn(ColumnId.PERFORMER, b);
                result = _sortColumn(av3.value, bv3.value, av3.type, 'asc');
            }
        }
        return result;
    });
    return nextFilteredRows;
}
